// https://vuex.vuejs.org/en/actions.html

import {
  AUTH,
  CHECK_AUTH,
  LOGOUT,
} from "./actions.type";

import axios from '@/plugins/axios'
import enviroment from '@/enviroment'
import UserService from '@/services/user'
import Cookies from 'js-cookie'


export default {

  [AUTH]({ commit, dispatch }, token) {
    return new Promise(async (resolve, reject) => {
      if (token) {
        commit(SET_TOKEN, token)
      } else {
        window.location = enviroment.authUrl
      }

      await UserService.getUserMe().then(res => {
        commit(SET_LOGGEDUSER, res)
        resolve()
      }).catch(() => {
        dispatch(LOGOUT)
      })
    })
  },
  [LOGOUT](state) {
    state.user = null
    state.token = null
    Cookies.remove('STRATEGY_TOKEN') // if the request fails, remove any possible user token if possible
    Cookies.remove('STRATEGY_USER')
    Cookies.set('URL_CONTINUE', window.location, {
      domain: enviroment.cookiesDomain,
      path: '/'
    })
  },
  [CHECK_AUTH](state) {
    if (state.user && state.token) {
      return true
    }

    const token = Cookies.get('STRATEGY_TOKEN')
    const user = Cookies.get('STRATEGY_USER')
    if (token && user) {
      state.token = token
      state.loggedUser = user
      state.configurations = Cookies.get('STRATEGY_CONFIG')
      axios.httpApi.defaults.headers.common['Authentication-Token'] = token
      return true
    }
    return false
  }
  //
}
